import React, { useEffect, useRef, useState } from "react";

import { Form, Formik } from "formik";
import clsx from "clsx";
import PropTypes from "prop-types";
import {
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  makeStyles,
  withStyles,
} from "@material-ui/core";
import stepperTick from "../../../../../Assets/applifecycle/stepper-tick.svg";
import styles from "../AppManage.module.scss";

export function FormikStepper({ children, stepCnt, app, ...props }) {
  const childrenArray = React.Children.toArray(children);
  const [step, setStep] = useState(stepCnt);
  const currentChild = childrenArray[step];
  const [completed, setCompleted] = useState(false);
  const bodyRef = useRef();
  const formRef = useRef();

  useEffect(() => {
    console.log(props, stepCnt, step, "this is props changings")

    if (props && !props.modalFlag && step === 2 && props.buildSkipFlag) {
      console.log(props, stepCnt, step, "this is props changings isnide if")
      setStep((s) => s + 1);
    }

    // if (props && !props.modalFlag && step === 3 && props.buildSkipFlag) {
    //   setStep((s) => s + 1);
    // }
  }, [props]);

  useEffect(() => {
    console.log("this is final setp count>>>>>>>>>>", stepCnt)
    if(step !== 2 && stepCnt !== 2 ) {
      console.log("this is final setp count>>>>>>>>>> inside if", stepCnt)
      setStep(stepCnt);
    }
  }, [stepCnt]);

  useEffect(() => {
    console.log("this is final setp count>>>>>>>>>>11111", step)
    setStep(step);
  }, [step]);

  
  const QontoConnector = withStyles({
    alternativeLabel: {
      top: 10,
      left: "calc(-50% + 16px)",
      right: "calc(50% + 16px)",
    },
    active: {
      "& $line": {
        borderColor: "#707070",
      },
    },
    completed: {
      "& $line": {
        borderColor: "#707070",
        borderLeft: "1.5px solid",
      },
    },
    line: {
      borderLeft: "1.5px dotted",
      borderColor: "#707070",
      borderTopWidth: 3,
      borderRadius: 1,
      marginBottom: "-8px",
      height: "50px",
    },
  })(StepConnector);

  const useQontoStepIconStyles = makeStyles({
    root: {
      color: "#eaeaf0",
      display: "flex",
      // height: 22,
      alignItems: "center",
    },
    active: {
      // color: '#707070',
    },
    circle: {
      width: 10,
      height: 10,
      marginLeft: "8px",
      borderRadius: "50%",
      backgroundColor: "#fb5050",
      cursor: "pointer",
    },
    completed: {
      width: 15,
      height: 15,
      marginLeft: "5px",
      borderRadius: "50%",
      backgroundColor: "#4288be",
      // color: '#707070',
      zIndex: 1,
      fontSize: 18,
      cursor: "pointer",
    },
  });

  function isLastStep() {
    return step === childrenArray.length - 1;
  }

  function QontoStepIcon(props) {
    const classes = useQontoStepIconStyles();
    const { active, completed } = props;

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
        })}
      >
        {completed ? (
          // <Check className={classes.completed} />
          <img alt="ui" src={stepperTick} className={classes.completed} />
        ) : (
          <div className={classes.circle} />
        )}
      </div>
    );
  }

  QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
  };

  return (
    <Formik
      innerRef={formRef}
      {...props}
      validationSchema={currentChild.props.validationSchema}
      onSubmit={async (values, helpers) => {
        console.log("came in submit form---------->")
        if (isLastStep()) {
          await currentChild.props.onSubmit(values, helpers);
          setCompleted(true);
        } else {
          currentChild.props.onSubmit(values, helpers);
          if (!props.modalFlag) {
            console.log("came in modal flag---------->", step, stepCnt)
            setStep((s) => s + 1);
          }
          bodyRef.current.scrollTop = 0;
          helpers.setTouched({});
        }
      }}
    >
      {({ isSubmitting, formik }) => (
        <Form autoComplete="off" className="app-manage">
          <div
            className=""
            style={{
              display: "flex",
              alignItems: "flex-start",
              position: "relative",
            }}
          >
            <h5 className={styles.labelA}>Store Listing</h5>
            <h5 className={styles.labelB}>Release Management</h5>
            <Stepper
              activeStep={step}
              orientation="vertical"
              style={{
                backgroundColor: "#1D1D1D",
                color: "white",
                borderTopLeftRadius: "8px",
                borderBottomLeftRadius: "8px",
                paddingTop: "3em",
                paddingBottom: "6em",
                paddingLeft: "10px",
              }}
              connector={<QontoConnector />}
            >
              {childrenArray.map((child, index) => (
                <Step
                  key={child.props.label}
                  completed={step > index || completed}
                  onClick={() => {
                    console.log(index, ">>>>>>>>>>>>>>>>>>><><><><><><><><>", completed)
                    if (child?.props?.setApkUploaded) {
                      child?.props?.setApkUploaded(false);
                    }
                    setStep((prev) =>
                      (prev === 2 && index === 3) || (prev === 3 && index === 2) ? index : prev
                    );
                  }}
                  style={{
                    backgroundColor: `${
                      index === step ? "#292929" : "transparent"
                    }`,
                    padding: `${index === step ? "10px 0" : ""}`,
                    margin: `${index === step ? "-10px 0" : ""}`,
                    marginRight: `${index === step ? "-30%" : ""}`,
                    borderRadius: `${index === step ? "4px" : ""}`,
                  }}
                >
                  <StepLabel
                    style={{ color: "white" }}
                    StepIconComponent={QontoStepIcon}
                  >
                    <div
                      style={{
                        color: `${index === step ? "white" : "#707070"}`,
                        fontFamily: "JioType-medium",
                        fontSize: "10px",
                        cursor: "pointer",
                      }}
                    >
                      {child.props.label}
                    </div>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
            <div ref={bodyRef} className={styles.formbody}>
              {currentChild}
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}
